import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiResourceActionCreator } from '../../common';
import { authTokenSelector } from '../../session';
import { apiAction as getCpdCategoryApiAction } from './getCpdCategory';
import { apiAction as getCpdCategoryProgressApiAction } from './getCpdCategoryProgress';

const actions = createActions({
  USER: {
    GET_CPD_CATEGORYS: (userId, query) => ({ userId, query }),
    API: {
      GET_CPD_CATEGORYS: apiResourceActionCreator('cpdCategorys')
    }
  }
})

export function* getCpdCategorys(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(getCpdCategoryApiAction(authToken));
    yield put(getCpdCategoryProgressApiAction(authToken, action.payload.query));
  }
}

const configuration = {
  name: 'getCpdCategorys',
  action: actions,
  sagas: getCpdCategorys,
  reducers: {
    request: (state, action) => ({
      ...state,
      currentUserCpdCategorys: [],
      currentUserCpdCategorysIsFetching: true
    }),
    success: (state, action) => ({
      ...state,
      currentUserCpdCategorys: action.payload.cpdCategorys.cpdCategorys,
      currentUserTotalCpdCategorys: action.payload.cpdCategorys,
      currentUserCpdCategorysIsFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      currentUserCpdCategorysIsFetching: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getCpdCategorys.js